export default (value, func) => new Promise((resolve) => {
    if (func !== undefined) {
        func(value);
    }

    resolve(value);
});
